import React, {Component, ErrorInfo, ReactNode} from 'react'
import Alert from './common/Alert'
import {getLogger} from '../services/logging'
import {getRootState} from '../store/store'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

const logger = getLogger('AppErrorBoundary')

export default class AppErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public state: ErrorBoundaryState = {
    hasError: false
  }

  public static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return {hasError: true}
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.logError('Application Error', {
      error,
      errorInfo
    })
    logger.logError('Redux State', {
      reduxState: getRootState()
    })
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto px-4 mt-4 lg:mt-8 max-w-screen-xl">
          <Alert type="error" className="p-8">
            An application error occurred. If the problem persists, please
            contact support:
            <a
              className="link"
              target="_blank"
              href="mailto:hello@placemakr.com"
            >
              hello@placemakr.com
            </a>
          </Alert>
        </div>
      )
    } else {
      return <>{this.props.children}</>
    }
  }
}
